import { ActionTree, GetterTree, Module, MutationTree } from 'vuex'
import { NotificationState, Notification } from '../types/notification'
import { RootState } from '../types/root'

const getDefaultState = (): NotificationState => {
  return {
    notifications: [],
    limit: 10,
  }
}

const moduleState = getDefaultState()

const ensureNumberOfNotificationsInLimit = (notifications: Notification[], limit: number) => {
  const number_of_too_many = notifications.length - limit
  if (number_of_too_many > 0) {
    return notifications.slice(number_of_too_many)
  }
  return notifications
}

export const moduleGetters: GetterTree<NotificationState, RootState> = {
  lastNotification(state) {
    return state.notifications[state.notifications.length - 1]
  },
}
export const moduleMutations: MutationTree<NotificationState> = {
  ADD_NOTIFICATION(state, { type, text }) {
    const newNotificationsArray = [...state.notifications, new Notification(type, text)]
    state.notifications = ensureNumberOfNotificationsInLimit(newNotificationsArray, state.limit)
  },
  ADD_ERROR_NOTIFICATION(state, text = 'Unknown error') {
    const newNotificationsArray = [...state.notifications, new Notification('error', text)]
    state.notifications = ensureNumberOfNotificationsInLimit(newNotificationsArray, state.limit)
  },
  ADD_SUCCESS_NOTIFICATION(state, text) {
    const newNotificationsArray = [...state.notifications, new Notification('success', text)]
    state.notifications = ensureNumberOfNotificationsInLimit(newNotificationsArray, state.limit)
  },
  resetState(state) {
    Object.assign(state, getDefaultState())
  },
}

export const moduleActions: ActionTree<NotificationState, RootState> = {
  success({ commit }, text) {
    commit('ADD_SUCCESS_NOTIFICATION', text)
  },
  error({ commit }, text) {
    commit('ADD_ERROR_NOTIFICATION', text)
  },
  async resetNotificationState({ commit }) {
    commit('resetState')
  },
}

const notification: Module<NotificationState, RootState> = {
  namespaced: true,
  state: moduleState,
  getters: moduleGetters,
  mutations: moduleMutations,
  actions: moduleActions,
}
export default notification
